export const ATHENA_URL = 'https://comma.dilos.link'
export const API_URL = 'https://comma.dilos.link'
export const BILLING_URL = 'https://comma.dilos.link'
export const USERADMIN_URL = 'https://comma.dilos.link'
